<template>
    <transition name="fade">
        <v-btn
            v-show="show"
            v-scroll="onScroll"
            position="fixed"
            location="bottom right"
            color="primary"
            icon="mdi-chevron-up"
            class="gst-scroll-top-button mr-4 mb-4"
            @click="scrollToTop" />
    </transition>
</template>
<script>
import { scrollTo } from '@utils/domUtils';

export default {
    name: 'ScrollToTopButton',
    data() {
        return {
            show: false,
        };
    },
    methods: {
        onScroll(e) {
            if (typeof window === 'undefined') return;
            const top = window.pageYOffset || e.target.scrollTop || 0;
            this.show = top > 100;
        },
        scrollToTop() {
            // this.$vuetify.goTo( 0 );
            scrollTo('body');
        },
    },
};
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
